/* @flow strict */

import * as React from 'react';
import './dropdown.scss';

type PropsType = {
    options: [],
    value?: string,
    name?: string,
    placeholder?: string,
    maxHeight?: number,
    onChange: () => void
};

const Dropdown = (props: PropsType): React.Element<'div'> => {
    const { value, name, maxHeight, options, placeholder, onChange } = props;
    const [isOpen, setOpen] = React.useState(false);
    const [caption, setCaption] = React.useState('');
    const optionsRef = React.useRef();

    const selectItem = (e: {}, text: string) => {
        onChange(e);
        setCaption(text);
        setOpen(false);
    };

      const closeOptions = (e: {}) => {
        if (optionsRef && !optionsRef.current.contains(e.target)) {
            setOpen(false);
          }
      };

   //  toggle onBlur
   React.useEffect((): void => {
    document.addEventListener('mousedown', closeOptions);
    return () => {
        document.removeEventListener('mousedown', closeOptions);
    };
}, []);

const arrowClasses = `sparxo-checkout-dropdown_fakeArrow ${isOpen ? 'sparxo-checkout-dropdown_arrowDown' : ''}`;
const optionClasses = `sparxo-checkout-dropdown_fakeOptions ${isOpen ? 'sparxo-checkout-dropdown_showOptions' : ''}`;

    return (
        <div className='sparxo-checkout-dropdown_container' ref={optionsRef}>
            <div style={{ position: 'relative' }}>
                <i className={arrowClasses} />
                <input
                  type="text"
                  value={caption}
                  readOnly
                  className='sparxo-checkout-dropdown_fakeSelectInput'
                  placeholder={placeholder}
                  spellCheck="false"
                  autoComplete="off"
                  onClick={(): void => setOpen((state: boolean): boolean => !state)}
                />
            </div>
            <div className={optionClasses}
              style={{ maxHeight: `${maxHeight}px` }}
            >
                {options.map((opt: {}): React.Element<'button'> => (
                    <button
                      type="button"
                      onClick={(e: {}): void => selectItem(e, opt.text)}
                      key={opt.id}
                      name={name || opt.question_id}
                      value={opt.id}
                      className={value === opt.id  ? 'sparxo-checkout-dropdown_selectedOption' : ''}
                    >
                        {
                            opt.text
                        }
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Dropdown;

